// src/config.js
// CRA build-time configuration (baked into bundle during `yarn build`).
// Do NOT use @mars/heroku-js-runtime-env for nginx static deployments.

const required = (name) => {
  const v = process.env[name];
  if (!v) {
    throw new Error(`Missing required environment variable: ${name}`);
  }
  return v;
};

const optional = (name, fallback) => {
  const v = process.env[name];
  return v !== undefined && v !== null && v !== "" ? v : fallback;
};

const optionalNumber = (name, fallback) => {
  const raw = optional(name, "");
  if (!raw) return fallback;
  const n = Number(raw);
  return Number.isFinite(n) ? n : fallback;
};

export const CONTACT_EMAIL_DEFAULT =
  optional("CONTACT_EMAIL_DEFAULT", "") || "support@offerboard.com";

export const CLOUDINARY_CLOUD_NAME = optional(
  "REACT_APP_CLOUDINARY_CLOUD_NAME",
  ""
);

export const CLOUDINARY_RECEIPT_UPLOAD_PRESET = optional(
  "REACT_APP_CLOUDINARY_RECEIPT_UPLOAD_PRESET",
  ""
);

// Fail fast: Apollo requires a real endpoint
export const GRAPHQL_URI = required("REACT_APP_GRAPHQL_URI");

export const INTRALINKS_VDR_URL = optional("REACT_APP_INTRALINKS_VDR_URL", "");

export const DASHBOARD_OFFER_LIMIT = optionalNumber(
  "REACT_APP_DASHBOARD_OFFER_LIMIT",
  60
);

export const CRYPTO_COMPARE_URL = optional("REACT_APP_CRYPTO_COMPARE_URL", "");
export const CRYPTO_COMPARE_KEY = optional("REACT_APP_CRYPTO_COMPARE_KEY", "");

export const KORECONX_URL = optional("REACT_APP_KORECONX_URL", "");
export const FUNDAMERICA_URL = optional("REACT_APP_FUNDAMERICA_URL", "");

export const INVESTOR_APP_DOMAIN = optional(
  "REACT_APP_INVESTOR_APP_DOMAIN",
  ""
);

export const RESTAPI_URI = optional(
  "REACT_APP_RESTAPI_URI",
  "http://localhost:4000/rest"
);

export const STRIPE_PUBLISHABLE_KEY = optional(
  "REACT_APP_STRIPE_PUBLISHABLE_KEY",
  ""
);

export const SESSION_IDLE_MINUTES = optionalNumber(
  "REACT_APP_SESSION_IDLE_MINUTES",
  60
);

export const CARD_MAX_LIMIT = optionalNumber(
  "REACT_APP_CARD_MAX_LIMIT",
  999999.99
);

export const ACH_MAX_LIMIT = optionalNumber("REACT_APP_ACH_MAX_LIMIT", 6000);

export const DATA_ROOM_API_URL = optional(
  "REACT_APP_DATA_ROOM_API_URL",
  "http://localhost:4000/api/dataroom"
);

export const RUNTIME_ENV = optional(
  "REACT_APP_RUNTIME_ENV",
  process.env.REACT_APP_RUNTIME_ENV || "DEV"
);



// WEBPACK FOOTER //
// ./src/config.js